import { getTitleThemeColor } from '../../../templates.js';
import { lightenHexColor } from '../../../utils/richText.js';

/** 分割线组件共用逻辑 */
export const dividerMixin = {
	props: {
		data: {
			type: Object,
			required: true,
		},
		editable: {
			type: Boolean,
			default: false,
		},
		active: {
			type: Boolean,
			default: false,
		},
		h5: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['select', 'update'],
	computed: {
		themeColor() {
			return getTitleThemeColor(this.data);
		},
		panelBackground() {
			return lightenHexColor(this.themeColor, 0.93);
		},
		gradientStyle() {
			return {
				background: `linear-gradient(to right, transparent, ${this.themeColor})`,
			};
		},
	},
	methods: {
		onWrapClick(e) {
			if (!this.editable) return;
			e?.stopPropagation?.();
			this.$emit('select');
		},
	},
};
